import React from 'react';
import cx from 'classnames';
import * as styles from './OMSubmitButton.scss';

const getHandlers = ({ onClick, disableSubmit }) => (disableSubmit && onClick
  ? { onClick }
  : {}
);

const OMSubmitButton = properties => (
  <button
    type={properties.disableSubmit ? 'button' : 'submit'}
    className={cx(styles.submitBtn, properties.className)}
    disabled={properties.disabled}
    {...getHandlers(properties)}
  >
    {properties.activeSpinner
      ? <i className={cx('icon icon-om-spinner om-pulse', styles.spinner)} />
      : (<span className="button-text">{properties.title}</span>)
    }
  </button>
);

export default OMSubmitButton;
